import { z } from 'zod'

import { ConceptChipWireSchema, toConceptChip } from '~/@entities/ConceptChip'
import type {
  LessonClassChallengeResponse,
  LessonClassChallengesResponse,
  UpsertChallengeSettingResponse,
} from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'

import {
  type AssignedChallenges,
  AssignedChallengeSchema,
  AssignedChallengesSchema,
  ChallengeChapterSchema,
  type LessonClassChallengeSetting,
  LessonClassChallengeSettingSchema,
  type SavedLessonClassChallengeSetting,
  SavedLessonClassChallengeSettingSchema,
} from './schemas'

// 유형칩의 대표 문제가 V2 문제 본체로 와서 유형칩 자리만 와이어 스키마로 바꿔 끼우고, 검증 뒤 toConceptChip 으로 푼다.
const _AssignedChallengesWireSchema = AssignedChallengesSchema.extend({
  challenges: z.array(
    AssignedChallengeSchema.extend({
      chapters: z.array(
        ChallengeChapterSchema.extend({ conceptChips: z.array(ConceptChipWireSchema) }),
      ),
    }),
  ),
})

export const adaptAssignedChallenges = (raw: LessonClassChallengesResponse): AssignedChallenges => {
  const assigned = parseApiResponse(_AssignedChallengesWireSchema, raw, 'AssignedChallenges')
  return (
    assigned && {
      ...assigned,
      challenges: (assigned.challenges ?? []).map((challenge) => ({
        ...challenge,
        chapters: (challenge.chapters ?? []).map((chapter) => ({
          ...chapter,
          conceptChips: (chapter.conceptChips ?? []).map(toConceptChip),
        })),
      })),
    }
  )
}

export const adaptLessonClassChallengeSettings = (
  raw: LessonClassChallengeResponse,
): LessonClassChallengeSetting[] =>
  parseApiResponse(
    z.object({ challengeSettings: z.array(LessonClassChallengeSettingSchema) }),
    raw,
    'LessonClassChallengeSetting',
  )?.challengeSettings ?? []

export const adaptSavedLessonClassChallengeSetting = (
  raw: UpsertChallengeSettingResponse,
): SavedLessonClassChallengeSetting =>
  parseApiResponse(SavedLessonClassChallengeSettingSchema, raw, 'LessonClassChallengeSetting')
